import { render, staticRenderFns } from "./OtherUserGamification.vue?vue&type=template&id=2525d83b&scoped=true&"
import script from "./OtherUserGamification.vue?vue&type=script&lang=js&"
export * from "./OtherUserGamification.vue?vue&type=script&lang=js&"
import style0 from "./OtherUserGamification.vue?vue&type=style&index=0&id=2525d83b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2525d83b",
  null
  
)

export default component.exports